import './app.css';

import $ from 'jquery';

// Slick (jQuery plugin)
import 'slick-carousel';

// Expose jQuery globally (some plugins expect it)
window.$ = $;
window.jQuery = $;

function isMobileMenu() {
  return $(window).width() < 1024;
}

function closeMenu() {
  $('.popup-menu').removeClass('opened');
  $('body').removeClass('locked');
}

$(document).ready(function () {
  // Smooth scroll to contact form
  $(document).on('click', 'a[href="#contact-form-box"]', function (e) {
    const $target = $('#contact-form-box');
    if (!$target.length) return;

    e.preventDefault();

    // Native scrollIntoView (not jQuery .offset()/scrollTop math): under the global
    // CSS `zoom` scale-down, manual coordinate math (jQuery offset AND
    // getBoundingClientRect) reports an inconsistent coordinate space, but the
    // browser's own scrollIntoView stays correct at any zoom level. Header
    // clearance comes from `scroll-margin-top` on the target (see scale.css).
    $target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    closeMenu();
  });

  $('#popup-menu-open').on('click', function (e) {
    e.preventDefault();
    $('.popup-menu').toggleClass('opened');
    $('body').toggleClass('locked');
  });

  $(document).on('click', '.close-menu', function (e) {
    if (!isMobileMenu()) return;
    e.preventDefault();
    closeMenu();
  });

  $(document).on('click', '.popup-menu', function () {
    if (!isMobileMenu()) return;
    closeMenu();
  });

  $(document).on('click', '.pop-menu-wrap', function (e) {
    e.stopPropagation();
  });

  $(window).on('resize', function () {
    if (!isMobileMenu()) {
      closeMenu();
    }
  });

  // Sliders (only initialize when element exists)
  if ($('.project-slider').length) {
    $('.project-slider').slick({
      slidesToShow: 1.5,
      slidesToScroll: 1,
      infinite: false,
      speed: 500,
      arrows: true,
      dots: false,
      autoplay: false,
      adaptiveHeight: false,
      centerMode: false,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="slick-prev project-arrow">' +
        '<img src="/assets/images/arrow-left.png" alt="Previous">' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next project-arrow">' +
        '<img src="/assets/icons/slider-arrows.svg" alt="Next">' +
        '</button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ($('.logo-slider').length) {
    $('.logo-slider').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      speed: 500,
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: false,
      centerMode: false,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="slick-prev logo-arrow">' +
        '<img src="/assets/images/arrow-left.png" alt="Previous">' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next logo-arrow">' +
        '<img src="/assets/icons/slider-arrows.svg" alt="Next">' +
        '</button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // Mobile dropdown behavior
  if (isMobileMenu()) {
    $('.popup-menu .menu-item ul').hide();
    $('.popup-menu h5').removeClass('active');
  }

  $(document).on('click', '.popup-menu h5', function (e) {
    if (!isMobileMenu()) return;

    e.preventDefault();
    e.stopPropagation();

    const $title = $(this);
    const $menu = $title.closest('.menu-item').find('ul').first();

    if (!$menu.length) return;

    $('.popup-menu .menu-item ul').not($menu).slideUp(200);
    $('.popup-menu h5').not($title).removeClass('active');

    $menu.stop(true, true).slideToggle(200);
    $title.toggleClass('active');
  });

  $(window).on('resize', function () {
    if (!isMobileMenu()) {
      $('.popup-menu .menu-item ul').removeAttr('style');
      $('.popup-menu h5').removeClass('active');
    } else {
      $('.popup-menu .menu-item ul').hide();
    }
  });
});
